import { db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';

// Return the start date for a given period
export function getStartDate(period) {
  const now = new Date();
  switch (period) {
    case 'daily':
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    case 'weekly': {
      const firstDayOfWeek = new Date(now);
      firstDayOfWeek.setDate(now.getDate() - now.getDay());
      return firstDayOfWeek;
    }
    case 'monthly':
      return new Date(now.getFullYear(), now.getMonth(), 1);
    case 'yearly':
      return new Date(now.getFullYear(), 0, 1);
    default:
      return new Date(0);
  }
}

// Generic ranking creator for a metric
export function getRanking(userStats, metric) {
  return Object.entries(userStats)
    .map(([userId, stats]) => ({
      userId,
      value: stats[metric],
      sessionCount: stats.sessionCount,
    }))
    .sort((a, b) => b.value - a.value);
}

// Fetch usernames for a list of user IDs, batching in groups of 10
export async function fetchUsernames(userIds) {
  const usernamesMap = {};
  const batches = [];

  for (let i = 0; i < userIds.length; i += 10) {
    const batch = userIds.slice(i, i + 10);
    const profilesQuery = query(
      collection(db, 'publicProfiles'),
      where('__name__', 'in', batch)
    );
    batches.push(getDocs(profilesQuery));
  }

  const results = await Promise.all(batches);
  results.forEach(snapshot => {
    snapshot.forEach(docSnap => {
  usernamesMap[docSnap.id] = docSnap.data().username || 'Unknown User';
    });
  });

  return usernamesMap;
}

// Format a duration (in seconds) to a human-readable string
export function formatTime(timeInSeconds) {
  const total = Number.isFinite(timeInSeconds) ? timeInSeconds : 0;
  const hrs = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  let secs = total - hrs * 3600 - mins * 60;
  secs = Number(secs.toFixed(2));

  // Handle rounding that could bump seconds to 60
  let adjMins = mins;
  if (secs >= 60) {
    adjMins += 1;
    secs = 0;
  }

  const formatSecs = (value) => (Number.isInteger(value) ? `${value}s` : `${value.toFixed(2)}s`);

  if (hrs > 0) {
    return `${hrs}h ${adjMins}m ${formatSecs(secs)}`;
  }
  if (adjMins > 0) {
    return `${adjMins}m ${formatSecs(secs)}`;
  }
  return formatSecs(secs);
}
